import React, { useState } from 'react';
import { TbLockCheck } from "react-icons/tb";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";
import AuthHeader from '../../components/Navbar/AuthHeader';
import { LuFileText } from "react-icons/lu";
import { useNavigate } from 'react-router-dom';
import ProgressSteps from '../../components/ProgressStep/ProgressSteps';
import { changePassword } from '../../actions/auth';

function SetPassword() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordType, setPasswordType] = useState("password");
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const email = localStorage.getItem('recoveryEmail');
    const otpCode = localStorage.getItem('otpCode');
    const navigate = useNavigate();

    // Password validation checks
    const passwordCriteria = [
        { id: 1, text: "At least 8 characters", isValid: (pass) => pass.length >= 8 },
        { id: 2, text: "1 uppercase character", isValid: (pass) => /[A-Z]/.test(pass) },
        { id: 3, text: "1 lowercase character", isValid: (pass) => /[a-z]/.test(pass) },
        { id: 4, text: "1 number", isValid: (pass) => /[0-9]/.test(pass) },
        { id: 5, text: "1 special character", isValid: (pass) => /[!@#$%^&*(),.?":{}|<>]/.test(pass) }
    ];

    const togglePasswordVisibility = (setter, currentType) => {
        setter(currentType === 'password' ? 'text' : 'password');
    };

    const validatePassword = () => {
        if (!passwordCriteria.every(criteria => criteria.isValid(password))) {
            setErrorMessage("Password does not meet the required criteria.");
            setTimeout(() => setErrorMessage(""), 5000);
            return false;
        }
        if (password !== confirmPassword) {
            setErrorMessage("Passwords do not match.");
            setTimeout(() => setErrorMessage(""), 5000);
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        setSuccessMessage("");
        
        if (!validatePassword()) return;

        if (!email || !otpCode) {
            // console.error("email or OTP code not found!");
            setTimeout(() => navigate('/password-reset'), 3000);
            return;
        }
        
        setIsLoading(true);
        try {
            const userData = {
                email,
                otp: otpCode,
                password: password,
                password_confirmation: confirmPassword,
            }; 

            await changePassword(userData);
            
            setSuccessMessage('Password changed successfully!');
            setTimeout(() => setSuccessMessage(""), 3000);
            setTimeout(() => navigate('/auth/success'), 3000);
        } catch (error) {
            setErrorMessage(error.message || "An error occurred, please try again.");
            setTimeout(() => setErrorMessage(""), 5000);
            setTimeout(() => navigate('/password-reset'), 3000);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div style={{ background: '#13053A', minHeight: '100vh' }}>
            <AuthHeader />
            <div className="auth__container padding__tb__30">
                <div className='auth__container__box'>
                    <h3>Set Password</h3>
                    <p className='auth__text'>This will enable you to log in to your account</p>
                    <ProgressSteps currentStep={3} totalSteps={3} />
                    <div className='auth__container__form w-full'>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12">
                                    <div className='form__group mb-4'>
                                        <label className='label__form'>Enter Password</label>
                                        <div className="input-group">
                                            <span className='auth__input__group'><TbLockCheck /></span>
                                            <input 
                                                type={passwordType} 
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                className='auth__input' 
                                            />
                                            <span className='auth__input__group end__0' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                                {passwordType === 'password' ? <IoMdEyeOff /> : <IoEye />}
                                            </span>
                                        </div>
                                        <div className="password-requirements mt-2 d-flex flex-wrap justify-content-center gap-2">
                                            {passwordCriteria.map(criteria => (
                                                <div key={criteria.id} className={`requirement-box ${criteria.isValid(password) ? 'valid' : ''}`}>
                                                    <LuFileText /> {criteria.text}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className='form__group mb-4'>
                                        <label className='label__form'>Confirm Password</label>
                                        <div className="input-group">
                                            <span className='auth__input__group'><TbLockCheck /></span>
                                            <input 
                                                type={passwordType} 
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                className='auth__input' 
                                            />
                                            <span className='auth__input__group end__0' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                                {passwordType === 'password' ? <IoMdEyeOff /> : <IoEye />}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {errorMessage && <p className="text-center text-danger error-container">{errorMessage}</p>}
                                {successMessage && <p className="text-center text-success success-container">{successMessage}</p>}
                                <div className='form__group mb-3'>
                                    <button type='submit' className='btn btn__block'>
                                        {isLoading ? (
                                            <div className="spinner-border spinner-border-sm text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ) : (
                                            "Confirm"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SetPassword;